import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDTitleText } from '@facet-wealth/design';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { withValueArray } from 'Helpers/MetaOverride';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withValueArray(FDBodyText),
  }, overrideReadOnly)
  .nameOverride('name', {
    _component: () => FDTitleText,
  }, overrideReadOnly);
